import { UserSettingsDropdown } from "components/modules/Navigation/Navbar/Account/Desktop/UserSettingsDropdown";
import { UserSettingsMenu } from "components/modules/Navigation/Navbar/Account/Mobile/UserSettingsMenu";
import useAuth from "components/modules/Auth/useAuth";
import { MobileLoginNavLink } from "components/modules/Navigation/Navbar/Account/Mobile/MobileLoginNavLink";
import { DesktopLoginNavLink } from "components/modules/Navigation/Navbar/Account/Desktop/DesktopLoginNavLink";

const UserAccountMenu = () => {
    const { isLoggedIn, isMounted } = useAuth();
    return (
        <>
            <div className="w-full lg:hidden">
                {isMounted && isLoggedIn() && <UserSettingsMenu />}
                {(!isMounted || !isLoggedIn()) && <MobileLoginNavLink />}
            </div>
            <div className="hidden lg:flex">
                <UserSettingsDropdown />
                <DesktopLoginNavLink />
            </div>
        </>
    );
};

export default UserAccountMenu;
